import { useState } from "react";
import { useVisitDetailStore } from "@/store/visits/visitDetail";
import { RateVisitSubmitted } from "./rate-visit-submitted";
import { RateVisitSuccess } from "./rate-visit-success";
import { RateVisitForm } from "./rate-visit-form";
import { useVisitByIdQuery } from "@/gqlhooks/visit/useVisitByIdQuery";
import { useVisitByClientWithTokenQuery } from "@/gqlhooks/visit/useVisitByClientWithTokenQuery";
import { LoadingDialog } from "@/components/shared/loading-dialog";
import { useAuth } from "@/components/shared/auth-provider";

export function VisitRateModalContainer({ token }: { token?: string }) {
  const [showSuccess, setShowSuccess] = useState(false);
  const [submittedRating, setSubmittedRating] = useState<number | null>(null);
  const { isAuthenticated } = useAuth();

  const visitId = useVisitDetailStore((state) => {
    return state.data.visitId;
  });
  const showRateVisitModal = useVisitDetailStore((state) => {
    return state.data.showRateVisitModal;
  });
  const closeRateVisitModal = useVisitDetailStore((state) => {
    return state.closeRateVisitModal;
  });

  const useTokenQuery = Boolean(token && showRateVisitModal);
  const useVisitIdQuery = Boolean(
    visitId && showRateVisitModal && !token && isAuthenticated,
  );

  const byToken = useVisitByClientWithTokenQuery(
    useTokenQuery ? { variables: { token: token ?? "" } } : { skip: true },
  );

  const byId = useVisitByIdQuery(
    useVisitIdQuery ? { variables: { id: visitId ?? "" } } : { skip: true },
  );

  const visitData = byToken.data ?? byId.data;
  const loading = byToken.loading || byId.loading;
  const error = byToken.error ?? byId.error;

  if (showRateVisitModal) {
    if (showSuccess) {
      return (
        <RateVisitSuccess
          open={showSuccess}
          rating={submittedRating ?? 0}
          onClose={() => {
            setShowSuccess(false);
            setSubmittedRating(null);
            closeRateVisitModal();
          }}
        />
      );
    }
    if (loading) {
      return <LoadingDialog open />;
    }
    if (error || !visitData) {
      return null;
    }
    const hasSubmittedRating = visitData.rating !== 0;
    if (hasSubmittedRating) {
      return <RateVisitSubmitted visitData={visitData} />;
    }
    return (
      <RateVisitForm
        visitData={visitData}
        onSuccess={(rating) => {
          setSubmittedRating(rating);
          setShowSuccess(true);
        }}
      />
    );
  }

  return null;
}
